{
  "metadata": {
    "id": "nightowl-light",
    "name": "Night Owl",
    "description": "Портировано из темы «Night Owl» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "nightowl.json",
      "project": "sdras",
      "url": "https://github.com/sdras/night-owl-vscode-theme",
      "upstreamFile": "packages/ui/src/theme/themes/nightowl.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 29.3,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.451,
      "paletteMaxS": 0.535,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.2,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 28.6,
      "syntaxVsTextMinDeltaE": 14.5,
      "chartsMinDeltaE": 25.0,
      "textSeparationDeltaE": 10.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#4876d6",
      "hover": "#416ac1",
      "active": "#3b61af",
      "foreground": "#000000",
      "muted": "#4876d680",
      "emphasis": "#4876d6"
    },
    "surface": {
      "background": "#f0f0f0",
      "foreground": "#2e2d3c",
      "muted": "#c3c2c8",
      "mutedForeground": "#414047",
      "elevated": "#acacb5",
      "elevatedForeground": "#403f53",
      "raised": "#92919d",
      "raisedForeground": "#2a2936",
      "overlay": "#f0f0f033",
      "subtle": "#d9d9dc"
    },
    "interactive": {
      "border": "#8b8a97",
      "borderHover": "#bfbec4",
      "borderFocus": "#4876d6",
      "selection": "#403f5324",
      "selectionForeground": "#403f53",
      "focus": "#4876d659",
      "focusRing": "#4876d647",
      "cursor": "#403f53",
      "hover": "#403f5317",
      "active": "#403f5324"
    },
    "status": {
      "error": "#d22523",
      "errorForeground": "#ffffff",
      "errorBackground": "#d225231a",
      "errorBorder": "#d2252359",
      "warning": "#ba4441",
      "warningForeground": "#ffffff",
      "warningBackground": "#ba44411a",
      "warningBorder": "#ba444159",
      "success": "#1f7972",
      "successForeground": "#ffffff",
      "successBackground": "#1f79721a",
      "successBorder": "#1f797259",
      "info": "#3366d1",
      "infoForeground": "#ffffff",
      "infoBackground": "#3366d11a",
      "infoBorder": "#3366d159"
    },
    "pr": {
      "open": "#1f7972",
      "draft": "#504f58",
      "blocked": "#ba4441",
      "merged": "#aa0982",
      "closed": "#d22523"
    },
    "syntax": {
      "base": {
        "background": "#c3c2c8",
        "foreground": "#403f53",
        "comment": "#4b4f4f",
        "keyword": "#723295",
        "string": "#0617de",
        "number": "#893230",
        "function": "#244b9f",
        "variable": "#403f53",
        "type": "#2f570b",
        "operator": "#0c0c0d"
      },
      "tokens": {
        "commentDoc": "#4b4f4f",
        "stringEscape": "#0c0c0d",
        "keywordImport": "#723295",
        "storageModifier": "#723295",
        "functionCall": "#244b9f",
        "method": "#244b9f",
        "variableProperty": "#244b9f",
        "variableOther": "#403f53",
        "variableGlobal": "#893230",
        "variableLocal": "#0c0c0d",
        "parameter": "#403f53",
        "constant": "#893230",
        "class": "#2f570b",
        "className": "#2f570b",
        "interface": "#2f570b",
        "struct": "#2f570b",
        "enum": "#2f570b",
        "typeParameter": "#2f570b",
        "namespace": "#2f570b",
        "module": "#723295",
        "tag": "#723295",
        "jsxTag": "#723295",
        "tagAttribute": "#244b9f",
        "tagAttributeValue": "#0617de",
        "boolean": "#893230",
        "decorator": "#723295",
        "label": "#244b9f",
        "regexp": "#0617de"
      }
    },
    "charts": {
      "series": [
        "#4876d6",
        "#3533d1",
        "#1f7972",
        "#ba4441",
        "#d22523"
      ]
    },
    "chat": {
      "background": "#f0f0f0",
      "userMessage": "#403f53",
      "userMessageBackground": "#acacb5",
      "assistantMessage": "#403f53",
      "assistantMessageBackground": "#c3c2c8",
      "timestamp": "#504f58",
      "divider": "#8b8a97",
      "typing": "#504f58"
    },
    "loading": {
      "spinner": "#4876d6",
      "spinnerTrack": "#c3c2c8",
      "skeleton": "#c3c2c8",
      "shimmer": "#bbbac1"
    },
    "tools": {
      "background": "#c3c2c8",
      "border": "#8b8a97",
      "headerHover": "#bcbbc2",
      "icon": "#2f63d0",
      "title": "#403f53",
      "description": "#504f58",
      "edit": {
        "added": "#1f7972",
        "addedBackground": "#1f79721a",
        "removed": "#d22523",
        "removedBackground": "#d225231a",
        "modified": "#3366d1",
        "modifiedBackground": "#3366d11a",
        "lineNumber": "#504f58"
      }
    },
    "markdown": {
      "heading1": "#403f53",
      "heading2": "#403f53",
      "heading3": "#403f53",
      "heading4": "#403f53",
      "link": "#3366d1",
      "linkHover": "#416ac1",
      "inlineCode": "#0617de",
      "inlineCodeBackground": "#c3c2c8",
      "blockquote": "#504f58",
      "blockquoteBorder": "#8b8a97",
      "listMarker": "#4473d5",
      "bold": "#403f53",
      "italic": "#403f53e6",
      "strikethrough": "#504f58",
      "hr": "#8b8a97"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8d3b47",
        "foreground": "#ffffff",
        "contrast": 7.37
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c16a45",
        "foreground": "#000000",
        "contrast": 5.42
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#927d42",
        "foreground": "#000000",
        "contrast": 5.23
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d5d57a",
        "foreground": "#000000",
        "contrast": 13.63
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#729b40",
        "foreground": "#000000",
        "contrast": 6.48
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#54c650",
        "foreground": "#000000",
        "contrast": 9.57
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dca3",
        "foreground": "#000000",
        "contrast": 12.99
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#459276",
        "foreground": "#000000",
        "contrast": 5.63
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#93dadc",
        "foreground": "#000000",
        "contrast": 13.3
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#417c90",
        "foreground": "#ffffff",
        "contrast": 4.66
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#314f92",
        "foreground": "#ffffff",
        "contrast": 7.88
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3841b9",
        "foreground": "#ffffff",
        "contrast": 8.0
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a490cf",
        "foreground": "#000000",
        "contrast": 7.47
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#ab47be",
        "foreground": "#ffffff",
        "contrast": 4.8
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#b54d8d",
        "foreground": "#ffffff",
        "contrast": 4.76
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d191a3",
        "foreground": "#000000",
        "contrast": 8.29
      }
    ]
  }
}
